module.exports = __webpack_public_path__ + "static/media/31.df771b89.jpg";